export default __webpack_public_path__ + "static/media/edital-cipaa-2026.710b4005.pdf";